import { render, staticRenderFns } from "./FormDetailPanel.vue?vue&type=template&id=155ce79a&scoped=true"
import script from "./FormDetailPanel.vue?vue&type=script&lang=js"
export * from "./FormDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./FormDetailPanel.vue?vue&type=style&index=0&id=155ce79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ce79a",
  null
  
)

export default component.exports